import { useId } from "react";
function useSafeId() {
  return useId().replace(/:/g, "_");
}
export {
  useSafeId
};
//# sourceMappingURL=useSafeId.mjs.map
